import { useMutation } from "@tanstack/react-query";
import { makeApiRequest3DDownload } from "@/src/services/api/postRequest3DDownload";

type Post3DDownload = {
  collectionSlug: string;
  tokenId: string;
  legalURL: string;
};

const useRequest3DDownloadMutation = (
  onError?: (response: any) => void,
  onSuccess?: () => void,
) => {
  const mutation = useMutation(
    async (props: Post3DDownload) => {
      const { tokenId, legalURL, collectionSlug } = props;
      return await makeApiRequest3DDownload(collectionSlug, tokenId, legalURL);
    },
    {
      onSuccess: () => {
        return onSuccess && onSuccess();
      },
      onError({ response }) {
        return onError && onError(response);
      },
    },
  );
  return mutation;
};

export default useRequest3DDownloadMutation;
